function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

function SvgDrawPolygonButton(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    ry: 4.5,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), React.createElement("path", {
    d: "m27,1c2.21,0,4,1.79,4,4v22c0,2.21-1.79,4-4,4H5c-2.21,0-4-1.79-4-4V5C1,2.79,2.79,1,5,1h22m0-1H5C2.24,0,0,2.24,0,5v22c0,2.76,2.24,5,5,5h22c2.76,0,5-2.24,5-5V5c0-2.76-2.24-5-5-5Z",
    style: {
      fill: "#0074d9",
      strokeWidth: 0
    }
  }), React.createElement("line", {
    x1: 8.88,
    y1: 22.95,
    x2: 23.26,
    y2: 22.95,
    style: {
      fill: "none",
      stroke: "#636569",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("rect", {
    x: 6.86,
    y: 21.45,
    width: 3,
    height: 3,
    style: {
      fill: "#636569",
      strokeWidth: 0
    }
  }), React.createElement("rect", {
    x: 22.14,
    y: 21.45,
    width: 3,
    height: 3,
    style: {
      fill: "#636569",
      strokeWidth: 0
    }
  }), React.createElement("line", {
    x1: 8.88,
    y1: 22.95,
    x2: 14.95,
    y2: 18.38,
    style: {
      fill: "none",
      stroke: "#636569",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("line", {
    x1: 16,
    y1: 15.34,
    x2: 19.65,
    y2: 7.55,
    style: {
      fill: "none",
      stroke: "#636569",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }))));
}

export default __webpack_public_path__ + "static/media/drawPolygonButton.9db2e770.svg";
export { SvgDrawPolygonButton as ReactComponent };